import React from 'react'
import { Card, CardContent } from "../../ui/card"
import { Lock, Shield, UserCheck, Key } from 'lucide-react'

export function AccessControl() {
  return (
    <section id="access" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-transparent to-purple-50/30 dark:from-slate-900/50 dark:via-transparent dark:to-slate-800/50"></div>
      <div className="container mx-auto max-w-[1200px] px-10 md:px-[72px] relative z-10">
        <div className="max-w-4xl mx-auto">
          <Card className="bg-background/90 backdrop-blur-xl border-border/80 shadow-2xl transition-all duration-300 overflow-hidden">
            <CardContent className="p-8 md:p-12">
              <div className="text-center space-y-8">
                  <div className="relative inline-block">
                    <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100 dark:from-blue-900/30 dark:via-indigo-900/30 dark:to-purple-900/30 flex items-center justify-center">
                      <Lock className="h-10 w-10 text-blue-600 dark:text-blue-400 animate-pulse" />
                    </div>
                    <div className="absolute inset-0 w-20 h-20 mx-auto rounded-full border-2 border-transparent border-t-blue-500/30 border-r-indigo-500/30 animate-spin" style={{ animationDuration: '3s' }}></div>
                  </div>
                  <div className="space-y-6">
                    <h2 className="text-3xl md:text-4xl font-bold">
                      <span className="bg-gradient-to-r bg-blue-500 bg-clip-text text-transparent">
                        Secure & Controlled Access 
                      </span> 
                    </h2>
                  </div>
                <div className="grid md:grid-cols-3 gap-6 mt-12">
                  <div className="group text-center space-y-3">
                    <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-blue-500/10 to-indigo-500/10 flex items-center justify-center group-hover:from-blue-500/20 group-hover:to-indigo-500/20 transition-all duration-300">
                      <Shield className="h-6 w-6 text-blue-600 dark:text-blue-400" />
                    </div>
                    <h3 className="font-semibold text-foreground">Enterprise Security</h3>
                    <p className="text-sm text-muted-foreground">End-to-end encryption and secure data handling</p>
                  </div>
                  <div className="group text-center space-y-3">
                    <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-purple-500/10 to-pink-500/10 flex items-center justify-center group-hover:from-purple-500/20 group-hover:to-pink-500/20 transition-all duration-300">
                      <UserCheck className="h-6 w-6 text-purple-600 dark:text-purple-400" />
                    </div>
                    <h3 className="font-semibold text-foreground">Approved Users Only</h3>
                    <p className="text-sm text-muted-foreground">Controlled access for internal team members</p>
                  </div>
                  <div className="group text-center space-y-3">
                    <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-orange-500/10 to-red-500/10 flex items-center justify-center group-hover:from-orange-500/20 group-hover:to-red-500/20 transition-all duration-300">
                      <Key className="h-6 w-6 text-orange-600 dark:text-orange-400" />
                    </div>
                    <h3 className="font-semibold text-foreground">Admin Controls</h3>
                    <p className="text-sm text-muted-foreground">Full administrative oversight and management</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}


